import { c as _c } from "react/compiler-runtime";
import { IcoLock16 } from '@onefootprint/icons';
type EncryptedCellProps = {
  prefix?: string;
};
const EncryptedCell = t0 => {
  const $ = _c(4);
  const {
    prefix
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gridTemplateColumns: "16px 1fr",
      gridTemplateRows: "1fr",
      gridTemplateAreas: "\"icon value\"",
      gap: "4px"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="[grid-area:icon] flex items-center justify-center"><IcoLock16 /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `${prefix ? `${prefix}` : "\u2022\u2022"}••••••••••`;
  let t4;
  if ($[2] !== t3) {
    t4 = <div className="grid items-center justify-end w-fit min-w-[88px] select-none pointer-events-none" style={t1}>{t2}<div className="[grid-area:value] text-body-2 text-primary text-right">{t3}</div></div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export default EncryptedCell;